import type { ConversationNodeIntegration } from 'lib-shared-types-api';

type RoutedThroughIntegrationProps = {
  node: ConversationNodeIntegration;
};

export function RoutedThroughIntegration({
  node,
}: RoutedThroughIntegrationProps): JSX.Element {
  return (
    <>
      Integration <strong>{node.http_request_type}</strong> ·{' '}
      {node.variables?.length ? (
        <>
          Variables <strong>{node.variables.join(', ')}</strong>
        </>
      ) : (
        'No variables created'
      )}
    </>
  );
}
